import { cfetch } from '@confluence/network';

export const useDismissCuration = () => {
	const dismissAction = async (neverShowAgain?: boolean): Promise<void> => {
		await cfetch(
			`/wiki/rest/internal/1.0/spaces/remote-objects/suggestions/dismiss?neverShowAgain=${neverShowAgain ?? false}`,
			{
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
			},
		);
	};

	return { dismissAction };
};
